import React from 'react';
import { Link } from '@tanstack/react-router';
import type { Profile } from '@interlucent/organization-protocol';
import { Badge } from '../shared';
import { profileService } from '../../services/profileService';
import styles from './ProfileCard.module.css';

interface ProfileCardProps {
  profile: Profile;
  projectId: string;
  mappingCount: number;
  onEdit: (profile: Profile) => void;
  onDelete: (profileId: string, profileName: string) => void;
  onToggleStatus: (profileId: string, isActive: boolean) => void;
  onManageMappings: (profileId: string) => void;
}

export function ProfileCard({
  profile,
  projectId,
  mappingCount,
  onEdit,
  onDelete,
  onToggleStatus,
  onManageMappings
}: ProfileCardProps) {
  const isActive = Boolean(profile.active);

  return (
    <Link
      to="/projects/$projectId/profiles/$profileId"
      params={{ projectId, profileId: profile.id }}
      className={styles.cardLink}
    >
      <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          <h3 className={styles.name}>{profile.name}</h3>
          <Badge variant={isActive ? 'success' : 'default'}>
            {isActive ? 'ACTIVE' : 'INACTIVE'}
          </Badge>
        </div>
      </div>

      <div className={styles.details}>
        <div className={styles.detailRow}>
          <span className={styles.label}>TYPE</span>
          <span className={styles.value}>
            {profileService.formatProfileType(profile.type)}
          </span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.label}>REGION</span>
          <span className={styles.value}>{profile.region}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.label}>APPLICATIONS</span>
          <span className={styles.value}>{mappingCount}</span>
        </div>
      </div>

      {profile.notes && (
        <div className={styles.notes}>{profile.notes}</div>
      )}

      <div className={styles.actions}>
        <button
          onClick={(e) => {
            e.preventDefault();
            onToggleStatus(profile.id, !isActive);
          }}
          className={styles.buttonSecondary}
        >
          {isActive ? 'Deactivate' : 'Activate'}
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            onManageMappings(profile.id);
          }}
          className={styles.buttonSecondary}
        >
          Manage Apps ({mappingCount})
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            onEdit(profile);
          }}
          className={styles.buttonSecondary}
        >
          Edit
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            onDelete(profile.id, profile.name);
          }}
          className={styles.buttonDanger}
        >
          Delete
        </button>
      </div>
    </div>
    </Link>
  );
}
